"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        backgroundColor: 'white',
        border: '1px solid transparent',
        borderRadius: 4,
        boxShadow: theme_1.default.shadows.weak,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        padding: 12,
        gap: 14,
        '&:hover': {
            border: "1px solid ".concat(theme_1.default.colors.primary),
        },
    },
    headContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        flex: '1',
    },
    selectedCard: {
        backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primary, 0.03),
        border: "1px solid ".concat(theme_1.default.colors.primary),
    },
    linkContent: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
}));
